<template>
  <section class="section container">
    <h1 class="title is-4 is-pulled-right mb-0">
      {{ $t("point of sale module configuration") }}
    </h1>

    <div class="field">
      <input
        class="is-checkradio"
        type="checkbox"
        id="chk_show_shopping_cart"
        v-model="meta.show_shopping_cart"
      />
      <label for="chk_show_shopping_cart">{{ $t("show shopping cart") }}</label>
    </div>

    <div class="container">
      <p class="buttons is-pulled-right">
        <button
          class="button is-secondary is-rounded"
          @click="add_payment_method"
        >
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </p>
      <h5 class="title is-5 pt-3">{{ $t("payment methods") }}</h5>
      <table
        class="table is-bordered is-fullwidth"
        v-if="meta && meta.payment_methods"
      >
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("percentage of use") }}</th>
            <th>{{ $t("options") }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rsrc, ridx) in meta.payment_methods" :key="ridx">
            <td>
              <input
                type="text"
                class="input"
                v-model="meta.payment_methods[ridx].name"
              />
            </td>
            <td>
              <input
                type="text"
                class="input"
                v-model="meta.payment_methods[ridx].percentage_of_use"
              />
            </td>
            <td>
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  :id="'chk_show_shopping_cart' + ridx"
                  v-model="meta.payment_methods[ridx].ask_for_document_number"
                />
                <label :for="'chk_show_shopping_cart' + ridx">{{
                  $t("ask for document number")
                }}</label>
              </div>
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  :id="'chk_link_to_visa' + ridx"
                  v-model="meta.payment_methods[ridx].link_to_visanet_payment"
                />
                <label :for="'chk_link_to_visa' + ridx">{{
                  $t("link to visanet payment")
                }}</label>
              </div>
            </td>
            <td>
              <button
                class="button is-secondary has-text-danger is-rounded"
                @click="meta.payment_methods.splice(ridx, 1)"
                :data-tooltip="$t('delete')"
              >
                <span class="icon">
                  <i class="fa fa-trash"></i>
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="is-divider"></div>
    <div class="columns">
      <div class="column">
        <h1 class="title is-5">{{ $t("visanet payment integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_visanet_payment"
            v-model="meta.integrate_visanet_payment"
          />
          <label for="chk_integrate_visanet_payment">{{
            $t("integrate visanet payment")
          }}</label>
        </div>
        <div class="field">
          <generic-dropdown
            :title="$t('profile')"
            :placeholder="$t('profile')"
            :is_multiple="false"
            url="/visanet_payment/profile/catalog"
            name_field="name"
            value_field="uuid"
            @selected="set_profile"
            ref="profile_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <h1 class="title is-5">{{ $t("inventory integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_inventory"
            v-model="meta.integrate_inventory"
          />
          <label for="chk_integrate_inventory">{{
            $t("integrate inventory")
          }}</label>
        </div>
        <div class="field">
          <generic-dropdown
            :title="$t('movement type to apply on sale')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/inventory/movement_type/catalog"
            name_field="name"
            value_field="movement_type_id"
            @selected="set_movement_type"
            ref="movement_type_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="field mt-5">
      <div class="control">
        <button class="button is-rounded is-primary" @click="save">
          <span class="icon"><i class="fa fa-save"></i></span>
          <span>{{ $t("save") }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
} from "@/utils";
import { isEmpty } from "lodash";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import "bulma-extensions/bulma-divider/dist/css/bulma-divider.min.css";

export default {
  name: "SaleSettings",
  components: { GenericDropdown },
  data() {
    return {
      meta: {
        show_shopping_cart: true,
        payment_methods: [],
      },
    };
  },
  methods: {
    save() {
      let v = this;
      v.$root.loader(true);
      save_configuration(this, v.meta)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    add_payment_method() {
      let v = this;
      v.meta.payment_methods.push({
        name: "",
        percentage_of_use: "",
        ask_for_document_number: false,
      });
    },
    set_profile(profile) {
      let v = this;
      v.meta.visanet_payment_profile = profile;
    },
    set_movement_type(movement_type) {
      let v = this;
      v.meta.inventory_movement_type_id = movement_type.movement_type_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (!isEmpty(conf)) {
          if (conf.visanet_payment_profile)
            v.$refs.profile_dropdown.set_value(conf.visanet_payment_profile);
          if (conf.inventory_movement_type_id)
            v.$refs.movement_type_dropdown.set_value(
              conf.inventory_movement_type_id
            );

          v.meta = conf;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
